//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

/**
 * These values are determined by Facebook and are not within our control. These are determined by Facebook
 * at a per-user level, and do not seem to be directly influenced by the page role(s) a user has.
 */
enum FacebookUserPermission {
  ReadInsights = 'read_insights',
  BusinessManagement = 'business_management',
  AdsRead = 'ads_read',
  AdsManagement = 'ads_management',
  CatalogManagement = 'catalog_management',
  PublicProfile = 'public_profile',
  UserPhotos = 'user_photos',
  PagesShowList = 'pages_show_list',
  InstagramManageComments = 'instagram_manage_comments',
  InstagramBasic = 'instagram_basic',
  InstagramManageInsights = 'instagram_manage_insights',
  InstagramContentPublish = 'instagram_content_publish',
  InstagramShoppingTagProducts = 'instagram_shopping_tag_products',

  // The below permissions have been directly swapped out for the deprecated manage_pages and publish_pages perms.
  // TODO: We should audit our Feature model to determine if all of the granular
  // perms are actually required for each of our Curalate "features". (DEV-55497)

  // manage_pages
  PagesManageAds = 'pages_manage_ads',
  PagesManageMetadata = 'pages_manage_metadata',
  PagesReadEngagement = 'pages_read_engagement',
  PagesReadUserContent = 'pages_read_user_content',

  // publish_pages
  PagesManagePosts = 'pages_manage_posts',
  PagesManageEngagement = 'pages_manage_engagement',

  // Instagram_manage_messages
  InstagramManageMessages = 'instagram_manage_messages',
}

export default FacebookUserPermission;
